import { render, staticRenderFns } from "./Create-Custom-Field.vue?vue&type=template&id=8302057e"
import script from "./Create-Custom-Field.vue?vue&type=script&lang=js"
export * from "./Create-Custom-Field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports